import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/JobRecurring/selectRow',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async save(params)
    {
        try
        {
            let response;
            if (typeof params.id !== 'undefined' && params.id != '')
            {
                response = await axios.post('/JobRecurring/updateRow', params);
            }
            else
            {
                response = await axios.post('/JobRecurring/insertRow', params);
            }
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/JobRecurring/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
